import React from 'react'

export interface BadgeProps {
  variant?: 'default' | 'green' | 'terra' | 'silver' | 'outline'
  children: React.ReactNode
  className?: string
  size?: string
}

const variantClasses: Record<string, string> = {
  default: 'bg-ink/5 text-ink-muted',
  green: 'bg-green/10 text-green',
  terra: 'bg-terra/10 text-terra',
  silver: 'bg-silver/20 text-ink-muted',
  outline: 'border border-silver text-ink-muted',
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ variant = 'default', children, className = '', ...rest }, ref) => {
    const classes = [
      'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-body font-medium',
      variantClasses[variant],
      className,
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <span ref={ref} className={classes} {...rest}>
        {children}
      </span>
    )
  }
)

Badge.displayName = 'Badge'

export default Badge
